import { useEffect, useState, type JSX } from 'react';
import { z } from 'zod';
import { uuidV7Schema } from '@cryptology-assist/domain';
import { request } from './api';
import { ErrorNotice, useMutation } from './components';
import type { Copy } from './copy';

const claimsSchema = z
  .object({
    companyId: uuidV7Schema,
    botId: uuidV7Schema,
    id: uuidV7Schema,
    token: z.string().min(20).max(200),
  })
  .strict();

export function AccountVerification({ copy }: { copy: Copy }): JSX.Element {
  const [claims] = useState(() =>
    claimsSchema.safeParse(
      Object.fromEntries(new URLSearchParams(window.location.hash.slice(1)))
    )
  );
  const [verified, setVerified] = useState(false);
  const mutation = useMutation();
  useEffect(() => {
    window.history.replaceState(null, '', window.location.pathname);
  }, []);
  return (
    <main className="confirmation-page">
      <p className="brand">{copy.product}</p>
      <h1>{copy.verifyAccount}</h1>
      <ErrorNotice error={mutation.error} copy={copy} />
      {!claims.success ? (
        <p>{copy.invalidLink}</p>
      ) : verified ? (
        <p role="status">{copy.accountVerifiedHelp}</p>
      ) : (
        <>
          <p>{copy.verifyAccountHelp}</p>
          <button
            className="primary"
            disabled={mutation.busy}
            onClick={() =>
              void mutation.run(async () => {
                const { companyId, botId, id, token } = claims.data;
                await request(
                  '/v1/verify-account',
                  z.object({
                    verified: z.literal(true),
                    expiresAt: z.string(),
                  }),
                  { body: { scope: { companyId, botId }, id, token } }
                );
                setVerified(true);
              })
            }
          >
            {copy.verifyAccount}
          </button>
        </>
      )}
    </main>
  );
}
